/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RepeatableShiftDeleteForm } from '../models/RepeatableShiftDeleteForm';
import type { RepeatableShiftOptions } from '../models/RepeatableShiftOptions';
import type { RepeatableShiftUpdateForm } from '../models/RepeatableShiftUpdateForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RepeatableShiftsService {
    /**
     * Create a new repeatable shift for the team. The shift can be created only for the team that the user is a member of.
     * @returns void
     * @throws ApiError
     */
    public static createRepeatableShift({
        requestBody,
    }: {
        requestBody: RepeatableShiftOptions,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/shifts/repeatable',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Repeatable shift conflict detected`,
            },
        });
    }
    /**
     * Delete a repeatable shift for the team. The shift can be deleted only for the team that the user is a member of.
     * @returns void
     * @throws ApiError
     */
    public static deleteRepeatableShift({
        target,
        repeatableShiftId,
        requestBody,
    }: {
        /**
         * The target of the repeatable shift that should be deleted
         */
        target: 'All' | 'Shift',
        repeatableShiftId: number,
        requestBody: RepeatableShiftDeleteForm,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/shifts/repeatable/{repeatableShiftId}/{target}/delete',
            path: {
                'target': target,
                'repeatableShiftId': repeatableShiftId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static updateRepeatableShift({
        repeatableShiftId,
        target,
        requestBody,
    }: {
        repeatableShiftId: number,
        target: 'All' | 'Shift',
        requestBody: RepeatableShiftUpdateForm,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/shifts/repeatable/{repeatableShiftId}/{target}',
            path: {
                'repeatableShiftId': repeatableShiftId,
                'target': target,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
